export type FileFormat = "pdf" | "word" | "spreadsheet" | "presentation" | "schedule" | "archive";

export interface FileFormatInfo {
    extension: string;
    format: FileFormat;
    label: string;
}

const FILE_FORMAT_BY_EXTENSION: Record<string, Omit<FileFormatInfo, "extension">> = {
    pdf: { format: "pdf", label: "PDF" },
    doc: { format: "word", label: "DOC" },
    docx: { format: "word", label: "DOC" },
    xls: { format: "spreadsheet", label: "XLS" },
    xlsx: { format: "spreadsheet", label: "XLS" },
    csv: { format: "spreadsheet", label: "CSV" },
    ppt: { format: "presentation", label: "PPT" },
    pptx: { format: "presentation", label: "PPT" },
    xer: { format: "schedule", label: "XER" },
    mpp: { format: "schedule", label: "MPP" },
    zip: { format: "archive", label: "ZIP" },
};

export function fileExtension(fileName: string | null | undefined): string {
    const match = /\.([a-z0-9]+)$/i.exec(fileName ?? "");
    return match ? match[1].toLowerCase() : "";
}

export function fileFormatFromName(
    fileName: string | null | undefined,
): FileFormatInfo | undefined {
    const extension = fileExtension(fileName);
    const format = FILE_FORMAT_BY_EXTENSION[extension];
    return format ? { extension, ...format } : undefined;
}

export function stripFileExtension(name: string): string {
    return name.replace(/\.[a-z0-9]+$/i, "");
}
